export default "__VITE_ASSET__284e28ac__"